import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static targets = ["searchInput", "clearButton"];

  connect() {
    if (this.hasSearchInputTarget && this.hasClearButtonTarget) {
      this.checkInitialState();
    }
  }
  checkInitialState() {
    this.toggleClearButton();
  }

  toggleClearButton() {
    if (this.searchInputTarget.value.trim().length > 0) {
      this.clearButtonTarget.classList.remove("invisible");
      this.clearButtonTarget.classList.add("visible");
    } else {
      this.clearButtonTarget.classList.remove("visible");
      this.clearButtonTarget.classList.add("invisible");
    }
  }

  removeAllQueryParametersFromUrl() {
    if (
      typeof window !== "undefined" &&
      window.location &&
      window.location.pathname
    ) {
      history.pushState(null, "", window.location.pathname);
    }
  }

  clearSearchWithTimeout(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const allSearchInputs = document.querySelectorAll(
      '[data-zoekveld-target="searchInput"]',
    );
    allSearchInputs.forEach((input) => (input.value = ""));
    setTimeout(() => {
      this.clearButtonTarget.classList.remove("visible");
      this.clearButtonTarget.classList.add("invisible");
    }, 10);
  }
}
